var map = {
	"./biomaterials.svg": 427,
	"./extraproduct.svg": 428,
	"./greenenergy.svg": 429,
	"./localproduction.svg": 430,
	"./paas.svg": 431,
	"./productredesign.svg": 432,
	"./renewablematerials.svg": 433,
	"./repairservice.svg": 434,
	"./residualflows.svg": 435,
	"./returnprogram.svg": 436,
	"./reuse.svg": 437,
	"./sloticon.svg": 438,
	"./solarpanels.svg": 439,
	"./spareparts.svg": 440,
	"./subsidy.svg": 441,
	"./wastevalorization.svg": 442
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 288;



//////////////////
// WEBPACK FOOTER
// ./app/assets/images/icons/cards nonrecursive ./~/raw-loader!\.svg$
// module id = 288
// module chunks = 2 5